import { apiFetch } from '../auth/AuthContext';

/**
 * Permanently deletes the signed-in user's ClassGrid data and logs them out.
 *
 * The backend requires the literal confirmation token so an accidental
 * `DELETE` cannot wipe an account.
 */
export async function deleteAccount() {
    const res = await apiFetch('/api/me', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ confirm: 'DELETE' }),
    });
    if (!res.ok) {
        let code = 'account_delete_failed';
        try {
            const data = await res.json();
            if (data && typeof data.error === 'string') code = data.error;
        } catch (e) {
            // Non-JSON body — keep the generic code.
        }
        throw new Error(code);
    }
    return res.json();
}

export function accountDeleteErrorMessage(code) {
    switch (code) {
        case 'not_authenticated':
            return 'Your session expired. Sign in again and retry.';
        case 'confirmation_required':
            return 'Type DELETE to confirm.';
        case 'missing_kerberos':
            return 'Your account is missing a kerberos id, so there is nothing to delete.';
        case 'database_unavailable':
            return 'The server cannot reach its database right now. Try again shortly.';
        default:
            return 'Could not delete your account. Try again, or email prashant@devclub.in.';
    }
}
